import React from "react";

import { Box, Stack } from "@origin-digital/ods-core";
import { RegisterSection } from "src/components/RegisterSection";
import { config } from "src/config";
import { FAQSection } from "./FAQSection";
import { HeroSection } from "./HeroSection";
import heroAssets from "./HeroSection/assets.json";
import { HowSection } from "./HowSection";
import { ParagraphSection, TileParagraphs } from "./ParagraphSection";
import { MediaSection } from "./MediaSection";
import { ISpikeContent } from "../../types";

export const Spike = (props: ISpikeContent) => {
  const {
    heroContent,
    paragraphContent,
    tileParagraphContent,
    registerContent,
  } = props;
  return (
    <Box data-id="origin-spike">
      <Stack space="xsmall">
        <Stack
          space={{
            sm: "none",
            xs: "xsmall",
          }}
        >
          <HeroSection content={heroContent} assets={heroAssets} />
          <ParagraphSection content={paragraphContent} />
        </Stack>
        <HowSection />
        <div id="video">
          <MediaSection />
        </div>
        <div id="eligible">
          <TileParagraphs
            //@ts-ignore
            content={tileParagraphContent}
          />
        </div>
        <RegisterSection
          backgroundColour="grey50"
          content={registerContent}
          link={
            config.env === "prod"
              ? registerContent.cta.prodLocation
              : registerContent.cta.nonProdLocation
          }
        />
        <FAQSection />
      </Stack>
    </Box>
  );
};
